import React from "react";
import Box from "@material-ui/core/Box";
import { DPCheckbox } from "Components/DP";
import { usePermissionsVisualizerContext } from "Components/PermissionsVisualizer/permissions-visualizer-context";

const PermissionVizToggle = () => {
  const { toggleVisualization } = usePermissionsVisualizerContext();

  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <Box marginLeft={1}>
      <DPCheckbox
        style={{ color: "white" }}
        label={"Turn on permission viz?"}
        onChange={toggleVisualization}
      />
    </Box>
  );
};

export default PermissionVizToggle;
